"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureStylePlugins = exports.configureQuestionAndAnswerPlugin = exports.configureAdvancedLinkPlugin = exports.configureLinkPlugin = exports.configureVideoPlugin = exports.configureEmbedPlugin = exports.configureRemoveEmbeddedImagePlugin = exports.configureAdvancedImagePlugin = exports.configureImagePlugin = exports.configureHighlightPlugin = exports.configureClipPlugin = exports.configureChangePlugin = void 0;

var _BlockStyles = _interopRequireDefault(require("draft-plugins/plugins/BlockStyles"));

var _link = _interopRequireDefault(require("draft-plugins/plugins/link"));

var _InlineStyles = _interopRequireDefault(require("draft-plugins/plugins/InlineStyles"));

var _BlockStylesDropdown = _interopRequireDefault(require("draft-plugins/plugins/BlockStylesDropdown"));

var _ListStylesDropdown = _interopRequireDefault(require("draft-plugins/plugins/ListStylesDropdown"));

var _AdvancedLinkPlugin = _interopRequireDefault(require("draft-advanced-link-plugin/AdvancedLinkPlugin"));

var _ChangePlugin = _interopRequireDefault(require("composer-plugins/plugins/ChangePlugin"));

var _ClipPlugin = _interopRequireDefault(require("composer-plugins/plugins/ClipPlugin"));

var _HighlightPlugin = _interopRequireDefault(require("composer-plugins/plugins/HighlightPlugin"));

var _ImagePlugin = _interopRequireDefault(require("composer-plugins/plugins/ImagePlugin"));

var _AdvancedImagePlugin = _interopRequireDefault(require("composer-plugins/plugins/AdvancedImagePlugin"));

var _RemoveEmbeddedImagePlugin = _interopRequireDefault(require("composer-plugins/plugins/RemoveEmbeddedImagePlugin"));

var _EmbedPlugin = _interopRequireDefault(require("composer-plugins/plugins/embed/EmbedPlugin"));

var _VideoPlugin = _interopRequireDefault(require("composer-plugins/plugins/video/VideoPlugin"));

var _QuestionEditorPlugin = _interopRequireDefault(require("composer-plugins/plugins/QuestionEditorPlugin"));

var _hubLVideo = require("FileManagerLib/utils/hubLVideo");

var _imageButtonBuilder = _interopRequireDefault(require("composer-lib/components/composer/buttons/imageButtonBuilder"));

var _embedButtonBuilder = _interopRequireDefault(require("composer-lib/components/composer/buttons/embedButtonBuilder"));

var _videoButtonBuilder = _interopRequireDefault(require("composer-lib/components/composer/buttons/videoButtonBuilder"));

var _entityButtonBuilder = _interopRequireDefault(require("composer-lib/components/composer/buttons/entityButtonBuilder"));

var _ClipComponent = _interopRequireDefault(require("composer-lib/components/clips/ClipComponent"));

var _AdvancedImage = _interopRequireDefault(require("composer-lib/components/composer/plugins/AdvancedImage"));

var _EditableVideoComponent = _interopRequireDefault(require("composer-lib/components/composer/plugins/EditableVideoComponent"));

var configureBlockStyles = function configureBlockStyles(_ref) {
  var allowedRichTextStyles = _ref.allowedRichTextStyles;
  return (0, _BlockStyles.default)(Object.assign({}, allowedRichTextStyles, {
    headerStyles: [],
    miscStyles: []
  }));
};

var configureChangePlugin = function configureChangePlugin() {
  return (0, _ChangePlugin.default)();
};

exports.configureChangePlugin = configureChangePlugin;

var configureClipPlugin = function configureClipPlugin(_ref2) {
  var options = _ref2.options;
  return (0, _ClipPlugin.default)(Object.assign({}, options, {
    entityButtonBuilder: _entityButtonBuilder.default,
    Clip: _ClipComponent.default
  }));
};

exports.configureClipPlugin = configureClipPlugin;

var configureHighlightPlugin = function configureHighlightPlugin() {
  return (0, _HighlightPlugin.default)();
};

exports.configureHighlightPlugin = configureHighlightPlugin;

var configureImagePlugin = function configureImagePlugin(_ref3) {
  var options = _ref3.options;
  return (0, _ImagePlugin.default)(Object.assign({}, options, {
    imageButtonBuilder: _imageButtonBuilder.default
  }));
};

exports.configureImagePlugin = configureImagePlugin;

var configureAdvancedImagePlugin = function configureAdvancedImagePlugin(_ref4) {
  var options = _ref4.options;
  return (0, _AdvancedImagePlugin.default)(Object.assign({}, options, {
    imageButtonBuilder: _imageButtonBuilder.default,
    ImageComponent: _AdvancedImage.default
  }));
};

exports.configureAdvancedImagePlugin = configureAdvancedImagePlugin;

var configureRemoveEmbeddedImagePlugin = function configureRemoveEmbeddedImagePlugin(_ref5) {
  var options = _ref5.options;
  return (0, _RemoveEmbeddedImagePlugin.default)(options);
};

exports.configureRemoveEmbeddedImagePlugin = configureRemoveEmbeddedImagePlugin;

var configureEmbedPlugin = function configureEmbedPlugin(_ref6) {
  var options = _ref6.options;
  return (0, _EmbedPlugin.default)(Object.assign({
    useUnstyledButton: true
  }, options, {
    embedButtonBuilder: _embedButtonBuilder.default
  }));
};

exports.configureEmbedPlugin = configureEmbedPlugin;

var configureVideoPlugin = function configureVideoPlugin(_ref7) {
  var options = _ref7.options;
  return (0, _VideoPlugin.default)(Object.assign({
    useUnstyledButton: true
  }, options, {
    getHubLVideoHubLTag: _hubLVideo.getHubLVideoHubLTag,
    videoButtonBuilder: _videoButtonBuilder.default,
    VideoComponent: _EditableVideoComponent.default
  }));
};

exports.configureVideoPlugin = configureVideoPlugin;

var configureLinkPlugin = function configureLinkPlugin(_ref8) {
  var options = _ref8.options;
  return (0, _link.default)(Object.assign({}, options, {
    tooltipPlacement: 'top'
  }));
};

exports.configureLinkPlugin = configureLinkPlugin;

var configureAdvancedLinkPlugin = function configureAdvancedLinkPlugin(_ref9) {
  var options = _ref9.options;
  return (0, _AdvancedLinkPlugin.default)(Object.assign({}, options));
};

exports.configureAdvancedLinkPlugin = configureAdvancedLinkPlugin;

var configureQuestionAndAnswerPlugin = function configureQuestionAndAnswerPlugin(_ref10) {
  var options = _ref10.options;
  return (0, _QuestionEditorPlugin.default)(options);
};

exports.configureQuestionAndAnswerPlugin = configureQuestionAndAnswerPlugin;

var configureStylePlugins = function configureStylePlugins(_ref11) {
  var allowedRichTextStyles = _ref11.allowedRichTextStyles;
  return {
    InlineStyles: (0, _InlineStyles.default)(Object.assign({}, allowedRichTextStyles.INLINE_STYLES, {
      allowClearStyles: false
    })),
    BlockStyles: configureBlockStyles({
      allowedRichTextStyles: allowedRichTextStyles
    }),
    BlockStylesDropdown: (0, _BlockStylesDropdown.default)(allowedRichTextStyles.BLOCK_STYLES, {
      use: 'on-dark'
    }),
    ListStylesDropdown: (0, _ListStylesDropdown.default)(allowedRichTextStyles.LIST_STYLES)
  };
};

exports.configureStylePlugins = configureStylePlugins;